// extracted by mini-css-extract-plugin
export var questionBox = "_a4-0";